
import React, { useState, useEffect } from "react";

import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectCartItems } from "../Redux/shoppingCartReducer";
import "../i18n/config";
import i18next from "i18next";
import GiftReceiverFormComponent from "./GiftReceiverForm";
import ShoppingCartItemComponent from "./ShoppingCartItem";
import CompanyShoppingCartComponent from "../components/CompanyComponents/CompanyShoppingCart";
import { useTranslation } from "../hooks/useTranslation";


function ShoppingCartComponent({setValue, register, handleSubmit, errors, sendNow, setSendNow, watch, ...props }) {
  const [lang, setLang] = useState("");
  const [giftTo, setGiftTo] = useState("other");
  const companyUser = useSelector((state) => state.company.companyUser)
  const { t } = useTranslation();
  const location = useLocation();
  let cartItems = useSelector(selectCartItems);
  const productsFromSession = window.sessionStorage.getItem("products");
  cartItems = productsFromSession ? JSON.parse(productsFromSession) : cartItems;

  const SetLanguage = (l) => {
    i18next.changeLanguage(l);
  };


  useEffect(() => {
    setLang(new URLSearchParams(location.search).get("lang") || "eng");

  }, []);


  useEffect(() => {
    SetLanguage(lang);
  }, [lang]);


  const sendGiftTo = (to) => {
    setGiftTo(to);
    if (to === "forme") {
      setValue("GiftEmailInput", "")
      setValue("GiftFreeTextInput", "")
      setValue("GiftSenderfullNameInput", "")
      setValue("GifteePhoneInput", "")
      setValue("GiftfullNameInput", "")
      setValue("gifteeTime", "")
      setValue("gifteeDate", "")
    }
  }

  return (
    <div className="shopping-cart-wrap">
      {
        companyUser ?
          <CompanyShoppingCartComponent register={register} handleSubmit={handleSubmit} errors={errors} />
          :
          <>
            {Object.keys(cartItems).map((k, ind) => {
              const currentItem = cartItems[k];
              const currentProduct = currentItem.selectedProduct;
              return <div key={ind}>
                <ShoppingCartItemComponent currentProduct={currentProduct} currentItem={currentItem} isConfirmation={props.isConfirmation} topCart={props.topCart}></ShoppingCartItemComponent>
              </div>
            })
            }
            {!props.isConfirmation && !props.topCart ?
              <>
                <h3 id="GiftTo" aria-label={t("GiftTo")} className="gift-to">{t("GiftTo")}</h3>
                <fieldset className="whosGift-wrap" aria-labelledby="GiftTo">

                    <input defaultChecked type="radio" id="ForSomeOneElse" name="giftTo" onChange={e => { if (e.target.checked) { sendGiftTo("other"); } }}/>
                    <label htmlFor="ForSomeOneElse" className="selection-btn">{t("ForSomeOneElse")}</label>

                    <input type="radio" id="ForMe" name="giftTo" onChange={e => { if (e.target.checked) { sendGiftTo("forme"); } }}/>
                    <label htmlFor="ForMe" className="selection-btn">{t("ForMe")}</label>
                </fieldset>
              </>
              : null

            }

            {((!props.isConfirmation && giftTo == "other") && !props.topCart) && <GiftReceiverFormComponent setValue={setValue} sendNow={sendNow} setSendNow={setSendNow} register={register} errors={errors} handleSubmit={handleSubmit} watch={watch}></GiftReceiverFormComponent>}
          </>
      }


    </div>
  );
}

export default ShoppingCartComponent;
